import { Box, Stack } from '@mantine/core';
import H3Medium from 'components/typography/H3Medium';
import KepGroupCard, { KepGroup } from 'components/modals/bulk-sign-revision-modal/KepGroupCard';

export interface RevisionGroup {
  departmentId: number;
  departmentName: string;
  groups: KepGroup[];
}

interface DepartmentGroupCardProps {
  group: RevisionGroup;
}

/**
 * Component that displays all KEP groups for a specific department.
 */
export default function DepartmentGroupCard({
  group: { departmentId, departmentName, groups: kepGroups },
}: DepartmentGroupCardProps) {
  return (
    <Box key={departmentId}>
      <H3Medium mb={12}>{departmentName}</H3Medium>
      <Stack spacing={12}>
        {kepGroups.map((kepGroup, idx) => (
          <KepGroupCard key={kepGroup.kepMessageUuid || `undefined-${idx}`} kepGroup={kepGroup} />
        ))}
      </Stack>
    </Box>
  );
}
